
import '../styling/NotFound.css';

const NotFound = () => {
    return (
        <section className="notfound">
            <div className="notfound_content">
                <h5>Oops!</h5>
                <h1>404</h1>
                <p>The page you're looking for doesn't exist.</p>
                <button
                    className="back_home_button"
                    onClick={() => window.location.href = '/'}
                >
                    Go Home
                </button>
            </div>
        </section>
    );
};

export default NotFound;
